import React from "react";

export default function Footer() {
  return (
    <div>
      <p style={{ textAlign: "center", margin: "7.5em 0" }}>
        Copyright &#169; {new Date().getFullYear()} Interosa Media | Powered by
        Interosa Media
      </p>
    </div>
  );
}
